import { theme, Typography } from 'antd';
import { TitleProps } from 'antd/es/typography/Title';
import { TextProps } from 'antd/es/typography/Text';
import { FC } from 'react';
import styled from '@emotion/styled';

const { useToken } = theme;

// Resets unwanted margins
// https://github.com/ant-design/ant-design/discussions/38753

const Wrapper = styled.div<{ marginBottom: number }>(
  {
    '& .ant-typography': {
      margin: '0',
    },
  },
  ({ marginBottom }) => ({
    marginBottom,
  })
);

export const Title: FC<TitleProps> = ({ children, className, ...props }) => {
  const { token } = useToken();

  return (
    <Wrapper marginBottom={token.marginMD} className={className}>
      <Typography.Title {...props}>{children}</Typography.Title>
    </Wrapper>
  );
};

export const Text: FC<TextProps> = ({ children, className, ...props }) => {
  const { token } = useToken();

  return (
    <Wrapper marginBottom={token.marginMD} className={className}>
      <Typography.Text {...props}>{children}</Typography.Text>
    </Wrapper>
  );
};
